var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('a',{staticClass:"expo-button expo-btn-white",attrs:{"title":_vm.$t('general.approve')},on:{"click":_vm.approve}},[_c('b-icon-check'),_vm._v(" "),_vm._t("default")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }